module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-yellow.e7fd3b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-yellow.svg
// module id = 5Nwh
// module chunks = 74